import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { setDrawer, setHeaderVisibility } from 'slices/drawer'
import { DRAWER_KEY, SUPPORT_STATUS_DRAWER_STAGES } from 'app-constants'
import { serviceOrderService } from 'services'
import { SupportResponse, AiSupportError } from './components'
import { ContextLoader } from '../../../context-loader'
import { DrawerHeader } from '../../../drawer-header'

export function AISupport() {
  const [data, setData] = useState(null)
  const [isLoading, setIsLoading] = useState(true)
  const { stage } = useSelector(({ drawer }) => drawer)
  const {
    selected: { id: contractId, unity },
  } = useSelector(({ contract }) => contract)
  const dispatch = useDispatch()
  const { getServiceOrderSupportStatus } = serviceOrderService()

  useEffect(() => {
    dispatch(setHeaderVisibility(false))
  }, [dispatch])

  useEffect(() => {
    async function fetchSupportDetails() {
      try {
        const { data: response } = await getServiceOrderSupportStatus(contractId, unity)
        setData(response)
      } catch (error) {
        dispatch(setDrawer(SUPPORT_STATUS_DRAWER_STAGES.ERROR))
      } finally {
        setIsLoading(false)
      }
    }

    fetchSupportDetails()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [contractId, unity, dispatch])

  function handleCloseClick() {
    dispatch(setDrawer(DRAWER_KEY.NONE))
  }

  function renderContent() {
    if (isLoading) return <ContextLoader fixed={false} />

    return stages({ data })[stage]
  }

  return (
    <>
      <DrawerHeader title='Giga+ Ajuda' color onClose={handleCloseClick} />
      {renderContent()}
    </>
  )
}

function stages({ ...props }) {
  return {
    [SUPPORT_STATUS_DRAWER_STAGES.RESPONSE]: <SupportResponse {...props} />,
    [SUPPORT_STATUS_DRAWER_STAGES.ERROR]: <AiSupportError {...props} />,
  }
}
